import Animation from '../../animations/sliding-animation'

class SlidingAnimation extends Animation {

}

export default SlidingAnimation
